import './IncrementalityBeaker.scss';
import cn from 'classnames';

interface IncrementalityBeakerProps {
  size?: number;
  className?: string;
}

// Shown to the right of a channel/feature name when that feature (or any
// sub-feature, at coarser granularities) has an incrementality test informing
// its model prior. A conical lab flask with the lower half filled; everything
// inherits `currentColor` (green, set in SCSS). The meaning is explained by the
// legend note in each container footer, so there is no hover tooltip here.
export const IncrementalityBeaker = ({ size = 16, className }: IncrementalityBeakerProps) => (
  <svg
    className={cn('dtc-commerce-mmm-incrementality-beaker', className)}
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth={1.6}
    strokeLinecap='round'
    strokeLinejoin='round'
    role='img'
    aria-label='Incrementality test prior'
  >
    {/* flask outline: rim, narrow neck, flared conical body, flat bottom */}
    <path d='M9 3.5 H15 M10 3.5 V8.7 L4.8 18.6 Q4.4 20.2 6.2 20.2 H17.8 Q19.6 20.2 19.2 18.6 L14 8.7 V3.5' />
    {/* liquid: lower half, solid (same green) */}
    <path
      d='M7.2 13.8 L4.8 18.6 Q4.4 20.2 6.2 20.2 H17.8 Q19.6 20.2 19.2 18.6 L16.8 13.8 Z'
      fill='currentColor'
      stroke='none'
    />
  </svg>
);
